<template>
  <div class="rider-mgmt-page">
  <ContentWrap>
    <el-alert
      class="mb-16px"
      type="info"
      :closable="false"
      title="运营端 · 骑手：档案台 + 认证审核。提交一律待审（无自动通过）。修改中(amending)可「解除修改锁」。不审机构入驻（归机构端）。"
    />

    <el-tabs v-model="activeTab" @tab-change="onTabChange">
      <el-tab-pane label="档案" name="archive">
        <div class="mb-12px flex flex-wrap gap-8px items-center">
          <el-input v-model="filter.city" placeholder="城市" clearable class="!w-120px" />
          <el-select v-model="filter.mode" placeholder="身份" clearable class="!w-120px">
            <el-option label="自由骑" value="free" />
            <el-option label="机构骑" value="org" />
          </el-select>
          <el-select v-model="filter.online" placeholder="在线" clearable class="!w-110px">
            <el-option label="在线" :value="true" />
            <el-option label="离线" :value="false" />
          </el-select>
          <el-select v-model="filter.certStatus" placeholder="认证态" clearable class="!w-130px">
            <el-option label="未完成" value="none" />
            <el-option label="待审" value="pending" />
            <el-option label="已通过" value="approved" />
            <el-option label="已驳回" value="rejected" />
            <el-option label="修改中" value="amending" />
          </el-select>
          <el-button type="primary" @click="searchArchive">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </div>

        <el-table
          :data="archiveList"
          v-loading="archiveLoading"
          border
          size="small"
          class="w-full"
          style="width: 100%"
        >
          <el-table-column prop="phone" label="手机号" min-width="130" />
          <el-table-column prop="realName" label="姓名" min-width="90" />
          <el-table-column prop="city" label="城市" min-width="80" />
          <el-table-column label="身份" min-width="120">
            <template #default="{ row }">
              {{ row.mode === 'org' ? `机构 ${row.orgId || ''}` : '自由骑' }}
            </template>
          </el-table-column>
          <el-table-column label="在线" min-width="80">
            <template #default="{ row }">
              <el-tag :type="row.online ? 'success' : 'info'" size="small">
                {{ row.online ? '在线' : '离线' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="认证" min-width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="certStatusTagType(row.certStatus)" size="small">
                {{ certStatusLabel(row.certStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="可上线" min-width="80">
            <template #default="{ row }">
              {{ row.canGoOnline ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="{ row }">
              <el-button link type="primary" @click="openDetail(row.phone)">详情</el-button>
              <el-button link type="warning" @click="onForceOffline(row.phone)">强下线</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="archiveTotal"
          v-model:page="archivePageNo"
          v-model:limit="archivePageSize"
          @pagination="loadArchive"
        />
      </el-tab-pane>

      <el-tab-pane label="认证审核" name="cert">
        <div class="mb-16px flex flex-wrap gap-12px items-center">
          <el-button type="primary" @click="loadPending">刷新待审</el-button>
          <el-input v-model="lookupPhone" placeholder="手机号查单条" class="!w-200px" clearable />
          <el-button @click="lookupCert">查询</el-button>
        </div>

        <el-table
          :data="certList"
          v-loading="certLoading"
          border
          size="small"
          class="w-full"
          style="width: 100%"
        >
          <el-table-column prop="phone" label="手机号" min-width="130" />
          <el-table-column prop="realName" label="姓名" min-width="100" />
          <el-table-column prop="idNumber" label="身份证号" min-width="160" />
          <el-table-column label="状态" min-width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="certStatusTagType(row.certStatus)" size="small">
                {{ certStatusLabel(row.certStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="证件" min-width="220">
            <template #default="{ row }">
              <div class="flex gap-8px flex-wrap">
                <el-image
                  v-if="row.idFrontUrl"
                  :src="row.idFrontUrl"
                  :preview-src-list="previewList(row)"
                  class="!w-56px !h-56px"
                  fit="cover"
                />
                <el-image
                  v-if="row.idBackUrl"
                  :src="row.idBackUrl"
                  :preview-src-list="previewList(row)"
                  class="!w-56px !h-56px"
                  fit="cover"
                />
                <el-image
                  v-if="row.healthCertUrl"
                  :src="row.healthCertUrl"
                  :preview-src-list="previewList(row)"
                  class="!w-56px !h-56px"
                  fit="cover"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="rejectReason" label="驳回原因" min-width="140" />
          <el-table-column label="操作" width="220" fixed="right">
            <template #default="{ row }">
              <template v-if="row.certStatus === 'amending'">
                <el-button link type="warning" @click="onUnlockAmend(row)">解除修改锁</el-button>
              </template>
              <template v-else>
                <el-button link type="success" @click="onReview(row, true)">通过</el-button>
                <el-button link type="danger" @click="onReject(row)">驳回</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="certTotal"
          v-model:page="certPageNo"
          v-model:limit="certPageSize"
          @pagination="loadPending"
        />
      </el-tab-pane>
    </el-tabs>

    <el-drawer v-model="drawer" title="骑手详情" size="420px">
      <template v-if="detail">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="手机">{{ detail.phone }}</el-descriptions-item>
          <el-descriptions-item label="姓名">{{ detail.realName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="城市">{{ detail.city }}</el-descriptions-item>
          <el-descriptions-item label="身份">
            {{ detail.mode === 'org' ? `机构骑 ${detail.orgId || ''}` : '自由骑' }}
          </el-descriptions-item>
          <el-descriptions-item label="在线">{{ detail.online ? '在线' : '离线' }}</el-descriptions-item>
          <el-descriptions-item label="认证">
            <el-tag :type="certStatusTagType(detail.certStatus)" size="small">
              {{ certStatusLabel(detail.certStatus) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="可上线">{{ detail.canGoOnline ? '是' : '否' }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.rejectReason" label="驳回原因">
            {{ detail.rejectReason }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="mt-16px flex flex-wrap gap-8px">
          <el-button type="warning" @click="onForceOffline(detail.phone!)">强制下线</el-button>
          <el-button
            v-if="detail.certStatus === 'amending'"
            type="danger"
            plain
            @click="onUnlockAmend({ phone: detail.phone!, certStatus: detail.certStatus })"
          >
            解除修改锁
          </el-button>
          <el-button @click="goPenalty(detail.phone!)">去处罚</el-button>
          <el-button type="primary" plain @click="goCertTab(detail.phone!)">看认证</el-button>
        </div>
        <div v-if="detail.idFrontUrl || detail.healthCertUrl" class="mt-16px flex gap-8px flex-wrap">
          <el-image
            v-for="(u, i) in previewList(detail)"
            :key="i"
            :src="u"
            :preview-src-list="previewList(detail)"
            class="!w-80px !h-80px"
            fit="cover"
          />
        </div>
      </template>
    </el-drawer>
  </ContentWrap>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ContentWrap } from '@/components/ContentWrap'
import * as RiderApi from '@/api/capacity/riderMgmt'
import * as CertApi from '@/api/capacity/riderCert'
import { certStatusLabel, certStatusTagType } from '@/api/capacity/labels'
import type { RiderCertItem } from '@/api/capacity/riderCert'
import type { PlatformRiderItem } from '@/api/capacity/riderMgmt'

defineOptions({ name: 'CapacityRiderMgmt' })

const route = useRoute()
const router = useRouter()

const activeTab = ref('archive')
const archiveLoading = ref(false)
const certLoading = ref(false)
const archiveList = ref<PlatformRiderItem[]>([])
const archivePageNo = ref(1)
const archivePageSize = ref(10)
const archiveTotal = ref(0)
const certList = ref<RiderCertItem[]>([])
const certPageNo = ref(1)
const certPageSize = ref(10)
const certTotal = ref(0)
const lookupPhone = ref('')
const drawer = ref(false)
const detail = ref<PlatformRiderItem | null>(null)

const filter = reactive<{
  city: string
  mode: string
  online: boolean | undefined
  certStatus: string
}>({
  city: '',
  mode: '',
  online: undefined,
  certStatus: '',
})

function previewList(row: { idFrontUrl?: string; idBackUrl?: string; healthCertUrl?: string }) {
  return [row.idFrontUrl, row.idBackUrl, row.healthCertUrl].filter(Boolean) as string[]
}

function syncTabFromQuery() {
  const t = String(route.query.tab || '')
  activeTab.value = t === 'cert' ? 'cert' : 'archive'
}

async function loadArchive() {
  archiveLoading.value = true
  try {
    const r = await RiderApi.listPlatformRiders({
      city: filter.city || undefined,
      mode: filter.mode || undefined,
      online: filter.online,
      certStatus: filter.certStatus || undefined,
      pageNo: archivePageNo.value,
      pageSize: archivePageSize.value,
    })
    archiveList.value = r?.list || []
    archiveTotal.value = r?.total || 0
  } finally {
    archiveLoading.value = false
  }
}

function searchArchive() {
  archivePageNo.value = 1
  loadArchive()
}

function resetFilter() {
  filter.city = ''
  filter.mode = ''
  filter.online = undefined
  filter.certStatus = ''
  archivePageNo.value = 1
  loadArchive()
}

async function loadPending() {
  certLoading.value = true
  try {
    const r = await CertApi.getPendingRiderCerts({
      pageNo: certPageNo.value,
      pageSize: certPageSize.value,
    })
    certList.value = r?.list || []
    certTotal.value = r?.total || 0
  } finally {
    certLoading.value = false
  }
}

async function lookupCert() {
  const phone = lookupPhone.value.trim()
  if (!phone) {
    ElMessage.warning('请输入手机号')
    return
  }
  certLoading.value = true
  try {
    const row = await CertApi.getRiderCert(phone)
    certList.value = row?.phone ? [row] : []
    certTotal.value = certList.value.length
    if (!row?.phone) ElMessage.info('未找到')
  } finally {
    certLoading.value = false
  }
}

async function onReview(row: RiderCertItem, approved: boolean, reason?: string) {
  if (!row.phone) return
  const r = await CertApi.reviewRiderCert({ phone: row.phone, approved, reason })
  if (r?.success === false) {
    ElMessage.error(r.message || '操作失败')
    return
  }
  ElMessage.success(approved ? '已通过' : '已驳回')
  await loadPending()
  await loadArchive()
}

async function onReject(row: RiderCertItem) {
  const { value } = await ElMessageBox.prompt('请填写驳回原因（骑手可见）', '驳回认证', {
    confirmButtonText: '驳回',
    cancelButtonText: '取消',
    inputPattern: /\S+/,
    inputErrorMessage: '原因不能为空',
  })
  await onReview(row, false, value)
}

async function onUnlockAmend(row: { phone?: string; certStatus?: string }) {
  if (!row.phone) return
  try {
    await ElMessageBox.confirm(
      `确认解除 ${row.phone} 的修改锁？将还原改前资料并恢复「已通过」。`,
      '解除修改锁',
      { type: 'warning' },
    )
  } catch {
    return
  }
  const r = await CertApi.unlockAmendRiderCert(row.phone)
  if (r?.success === false) {
    ElMessage.error(r.message || '解锁失败')
    return
  }
  ElMessage.success('已恢复已通过')
  await loadPending()
  await loadArchive()
  if (detail.value?.phone === row.phone) {
    await openDetail(row.phone)
  }
}

async function openDetail(phone?: string) {
  if (!phone) return
  const row = await RiderApi.getPlatformRider(phone)
  if (row?.success === false || !row?.phone) {
    ElMessage.warning(row?.message || '未找到')
    return
  }
  detail.value = row
  drawer.value = true
}

async function onForceOffline(phone?: string) {
  if (!phone) return
  try {
    await ElMessageBox.confirm(`确认强制下线 ${phone}？有进行中运单将失败。`, '强制下线', {
      type: 'warning',
    })
  } catch {
    return
  }
  const r = await RiderApi.forceOfflineRider(phone)
  if (!r?.success) {
    ElMessage.error(r?.message || '下线失败')
    return
  }
  ElMessage.success(r.message || '已强制下线')
  await loadArchive()
  if (detail.value?.phone === phone) {
    await openDetail(phone)
  }
}

function goPenalty(phone: string) {
  router.push({ path: '/distribution/penalty', query: { phone } })
}

function goCertTab(phone: string) {
  lookupPhone.value = phone
  activeTab.value = 'cert'
  router.replace({ query: { ...route.query, tab: 'cert' } })
  lookupCert()
  drawer.value = false
}

function onTabChange(name: string | number) {
  const tab = String(name)
  router.replace({ query: { ...route.query, tab: tab === 'cert' ? 'cert' : 'archive' } })
  if (tab === 'cert') loadPending()
  else loadArchive()
}

watch(
  () => route.query.tab,
  () => {
    syncTabFromQuery()
  },
)

onMounted(async () => {
  syncTabFromQuery()
  if (activeTab.value === 'cert') {
    await loadPending()
  } else {
    await loadArchive()
  }
})
</script>

<style scoped>
.rider-mgmt-page {
  width: 100%;
  box-sizing: border-box;
}
.rider-mgmt-page :deep(.el-card) {
  width: 100%;
}
</style>
